export default __webpack_public_path__ + "static/media/btn-gnb-user.e644a194.svg";